import ApplicationController from './application_controller'
import * as tableModule from '../packs/tabulator/tabulator';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { Controller } from "@hotwired/stimulus"

export default class extends ApplicationController {
    static targets = ["dateField", "editForm"]

    get vacanciesController() {
        return this.application.getControllerForElementAndIdentifier(document.querySelector(".js-room-order"), "vacancies")
    }
    get utilController() {
        return this.application.getControllerForElementAndIdentifier(document.querySelector(".table-section.table-wrapper"), "util")
    }
    connect() {
        super.connect()
        console.log("Cleaning controller connected")
    }

    toggle(e) {
        console.log("toggle");
        const el = document.querySelector(`#${e.target.dataset.id}`)
        el.classList.toggle('hide')
    }

    select_tab(e) {
        const tabName = e.target.dataset.tab 
        const buttons = document.querySelectorAll(".tab-button")
        buttons.forEach(button => {
            button.classList.remove("btn-secondary")
            button.classList.add("btn-flat")
        })
        e.target.classList.add("btn-secondary") 
        e.target.classList.remove("btn-flat") 
        const tabs = document.querySelectorAll(".tab")
        tabs.forEach(tab => {
            if (tab.classList.contains(tabName)) {
                tab.classList.remove("hide")
                const table = tableModule.getTable(tab)
                table.redraw(true)
            }
            if (!tab.classList.contains(tabName)) tab.classList.add("hide")
        })
    }
    async add_cleaning_order(e) {
        const wrapper = e.target.closest(".table-section.table-wrapper");
        if (!wrapper) {
            console.error("Could not find wrapper element");
            return;
        }
        
        const tableWrapperID = wrapper.id;
        console.log("Table wrapper ID:", tableWrapperID);
        
        let table;
        try {
            table = tableModule.getTable(wrapper);
            if (!table) {
                console.error("Table not found for wrapper:", wrapper);
                return;
            }
        } catch (error) {
            console.error("Error getting table:", error);
            return;
        }
        
        let data;
        try {
            data = table.getSelectedData();
            console.log("Selected data:", data);
            
            if (data.length === 0) {
                alert("יש לבחור חדרים לניקיון");
                return;
            }
        } catch (error) {
            console.error("Error getting selected data:", error);
            return;
        }
        
        // Get the global values from form elements
        const globalCleaningTimeInput = document.querySelector('[data-cleaning-target="globalCleaningTime"]');
        const globalCleaningTypeInput = document.querySelector('[data-cleaning-target="globalCleaningType"]');
        
        // Default to current time if not set
        const globalCleaningTime = globalCleaningTimeInput ? 
          globalCleaningTimeInput.value : 
          new Date().toTimeString().split(' ')[0].substring(0, 5);
        
        // Default to regular (0) if not set
        const globalCleaningType = globalCleaningTypeInput ? 
          parseInt(globalCleaningTypeInput.value, 10) : 0;
        
        const dateInput = document.querySelector("input[data-vacancies-target='date']");
        if (!dateInput) {
            console.error("Date input not found");
            return;
        }
        const date = dateInput.value;
        
        // Extract room IDs properly
        const ids = data.map(row => {
            const id = row.room_id || row.id || row.space_id;
            console.log(`Using ID: ${id} for row:`, row);
            return id;
        }).filter(id => id); // Remove any undefined or null IDs
        
        if (ids.length === 0) {
            alert("לא נמצאו מזהי חדרים תקינים בנתונים הנבחרים");
            return;
        }
        
        const notes = [];

        data.forEach(row => {
            // Convert sheets and towels to boolean values
            let sheetsValue = this.normalizeBoolean(row.vacancy_sheets || row.vacancy_sheets_custom);
            let towelsValue = this.normalizeBoolean(row.vacancy_towels || row.vacancy_towels_custom);
            let guestCount = parseInt(row.vacancy_guest_count || row.vacancy_guest_count_custom);

            notes.push({
                id: row.vacancy_id || row.room_id || row.id || row.space_id,
                type: row.space_kind || "room",
                num_in_room: guestCount,
                sheets: sheetsValue,
                towels: towelsValue,
                note: row.notes || row.notes_custom || "",
                cleaning_type: globalCleaningType || row.cleaning_type || "0"
            });
        });
        
        // Make sure we're passing the correct parameters in the same format that worked before
        this.stimulate("vacancies#set_order_expected_date", 
            date, 
            ids, 
            notes, 
            globalCleaningTime, 
            globalCleaningType
        ).then(() => {
            const el = document.getElementById(`new-order-room-cleaning-modal`);
            if (el) {
                el.classList.add('hide');
            }
            
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }).catch(error => {
            alert("שגיאה בשליחת הזמנת הניקיון: " + (error.message || "אנא נסה שנית"));
        });
    }

    // Add a helper method to normalize boolean values
    normalizeBoolean(value) {
        if (value === undefined || value === null) return false;
        if (typeof value === 'boolean') return value;
        if (typeof value === 'string') {
            return ['true', 'yes', 'on', '1', 'כן'].includes(value.toLowerCase());
        }
        return Boolean(value);
    }

    async edit_vacancy_notes  (e) {
        const wrapper = e.target.closest(".table-section.table-wrapper")
        const table = tableModule.getTable(wrapper)
        const columns = table.getColumnDefinitions().filter(col => col.isEditable)
        const col = await this.utilController.openSelectModal(e,columns)
        const date = this.vacanciesController.dateTarget.value
        const data = table.getSelectedData();

        data.sort(function (a, b) {
            return a.vacancy_id - b.vacancy_id;
          });
        const vacancy_ids = data.map(e => e.vacancy_id)

        if (!col) return
        const column = columns.filter(column => column.field == col)[0]
        let dataType = column.dataType
        if (dataType == "sheets" || dataType == "towels") dataType = "checkbox"
        if (dataType == "notes") dataType = "input"
        let value = await this.utilController.openInputModal(e, dataType, [])
        
        if (!value) return
        if (value == "on") value = true
        if (value == "off") value = false
        const model = "vacancy"
        const colName = col.substring(`${model}_`.length)
        this.stimulate("Vacancies#vacancy_update", vacancy_ids,colName,model,value).then(() => {
            table.setData();
        })
    }


    async edit_space_notes  (e) {
        const wrapper = e.target.closest(".table-section.table-wrapper")
        const table = tableModule.getTable(wrapper)
        const columns = table.getColumnDefinitions().filter(col => col.isEditable)
        const col = await this.utilController.openSelectModal(e,columns)
        if (!col) return
        const column = columns.filter(column => column.field == col)[0]
        const options = column.enumTypes.map(e => {
            let rObj = {}
            rObj.field = e
            rObj.title = e
            return rObj
         })
        console.log(column);
        let value = await this.utilController.openInputModal(e,column.dataType,options)
        console.log(value)
        if (!value) return
    
        const selectedRows = table.getSelectedRows()

        if (value == "on") value = true
        if (value == "off") value = false
        
        selectedRows.forEach(row => {
            const updateObj = row.getData()
            updateObj[column.field] = value
            console.log(updateObj);
            row.update(updateObj)
        })

    }
    checkIsTrue(obj){
        if (obj == 'true' || obj == "True" || obj == "כן") return true
        if (obj === true ) return true
        if (obj == "לא" || obj == "") return false
        return false
      }

    getData(e){
        
        const wrapper = e.target.closest(".table-section.table-wrapper")
        const table = tableModule.getTable(wrapper)
        console.log(tableModule.getAllTables());
        console.log(table.getColumnDefinitions());
    }

    resetToToday(event) {
        event.preventDefault()
        
        // Find the date input field within the form
        const dateForm = this.element.querySelector('.date-selector-form')
        const dateField = dateForm.querySelector('input[type="date"]')
        
        // Set to today's date in YYYY-MM-DD format
        const today = new Date()
        const formattedDate = today.toISOString().split('T')[0]
        
        // Set the value and submit the form
        dateField.value = formattedDate
        dateForm.submit()
    }

    async editRow(e) {
        const cleaningId = e.target.dataset.id;
        
        if (!cleaningId) {
            console.error("No cleaning ID found in button data", e.target);
            return;
        }
        
        try {
            // Fetch actual cleaning data from the server
            const response = await fetch(`/vacancies/${cleaningId}.json`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const cleaningData = await response.json();
            
            console.log("Fetched cleaning data:", cleaningData);
            
            // Store controller instance globally for modal callbacks
            window.cleaningController = this;
            
            // Create a modal for editing with improved styling
            const spaceOptions = await this.getSpaceOptions(cleaningData.space_id);
            const modalHtml = `
                <div class="edit-cleaning-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: center; font-family: 'Assistant', sans-serif;">
                    <div class="modal-content" style="background: #fafafa; border-radius: 5px; box-shadow: 0 4px 8px rgba(0,0,0,0.2); max-width: 600px; width: 90%; max-height: 90%; overflow-y: auto; direction: rtl;">
                        <div class="modal-header" style="background: #176e4d; color: white; padding: 20px 30px; border-radius: 5px 5px 0 0; text-align: center;">
                            <h3 style="margin: 0; font-size: 24px; font-weight: 600;">עריכת ניקיון</h3>
                        </div>
                        
                        <div class="modal-body" style="padding: 30px; background: white;">
                            <form id="edit-cleaning-form" style="display: grid; gap: 20px;">
                                <div class="form-row" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                                    <div class="form-group">
                                        <label for="edit_space_id" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">חדר:</label>
                                        <select id="edit_space_id" name="space_id" class="form-control" required 
                                                style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px; background: white;">
                                            ${spaceOptions}
                                        </select>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label for="edit_expected_date" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">תאריך ניקיון:</label>
                                        <input type="date" id="edit_expected_date" name="cleaning_expected_date" 
                                               value="${cleaningData.expected_date || ''}" required
                                               style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px;">
                                    </div>
                                </div>
                                
                                <div class="form-row" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                                    <div class="form-group">
                                        <label for="edit_cleaning_type" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">סוג ניקיון:</label>
                                        <select id="edit_cleaning_type" name="cleaning_type" 
                                                style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px; background: white;">
                                            <option value="regular" ${(cleaningData.cleaning_type == 'regular') ? 'selected' : ''}>רגיל</option>
                                            <option value="light" ${(cleaningData.cleaning_type == 'light') ? 'selected' : ''}>קל</option>
                                            <option value="thorough" ${(cleaningData.cleaning_type == 'thorough') ? 'selected' : ''}>יסודי</option>
                                            <option value="none" ${(cleaningData.cleaning_type == 'none') ? 'selected' : ''}>ללא</option>
                                        </select>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label for="cleaning_time" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">שעת ניקיון:</label>
                                        <input type="time" id="cleaning_time" name="cleaning_time" 
                                               value="${cleaningData.cleaning_time || ''}"
                                               style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px;">
                                    </div>
                                </div>
                                
                                <div class="form-row" style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; align-items: end;">
                                    <div class="form-group">
                                        <label for="guest_count" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">מספר לנים:</label>
                                        <input type="number" name="guest_count" value="${cleaningData.guest_count || 0}" min="0" 
                                               style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px;">
                                    </div>
                                    
                                    <div class="form-group" style="display: flex; align-items: center; gap: 10px; padding: 12px; background: #f8f9fa; border-radius: 5px; border: 1px solid #cccccc;">
                                        <input type="checkbox" name="sheets" id="sheets_checkbox" ${cleaningData.sheets ? 'checked' : ''}
                                               style="width: 18px; height: 18px; accent-color: #176e4d;">
                                        <label for="sheets_checkbox" style="font-weight: 600; color: #333; font-size: 14px; margin: 0; cursor: pointer;">מצעים</label>
                                    </div>
                                    
                                    <div class="form-group" style="display: flex; align-items: center; gap: 10px; padding: 12px; background: #f8f9fa; border-radius: 5px; border: 1px solid #cccccc;">
                                        <input type="checkbox" name="towels" id="towels_checkbox" ${cleaningData.towels ? 'checked' : ''}
                                               style="width: 18px; height: 18px; accent-color: #176e4d;">
                                        <label for="towels_checkbox" style="font-weight: 600; color: #333; font-size: 14px; margin: 0; cursor: pointer;">מגבות</label>
                                    </div>
                                </div>
                                
                                <div class="form-group">
                                    <label for="notes" style="display: block; margin-bottom: 8px; font-weight: 600; color: #333; font-size: 14px;">הערות:</label>
                                    <textarea name="notes" rows="4" placeholder="הוסף הערות נוספות..."
                                              style="width: 100%; padding: 12px; border: 1px solid #cccccc; border-radius: 5px; font-size: 14px; resize: vertical; font-family: inherit;">${cleaningData.notes || ''}</textarea>
                                </div>
                            </form>
                        </div>
                        
                        <div class="modal-footer" style="padding: 20px 30px; background: #f8f9fa; border-radius: 0 0 5px 5px; display: flex; gap: 12px; justify-content: flex-start;">
                            <button type="button" onclick="window.cleaningController.saveEditedCleaning(event)" 
                                    data-id="${cleaningId}" 
                                    style="background: #176e4d; color: white; border: 1px solid #176e4d; padding: 12px 24px; border-radius: 5px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background-color 0.2s ease;"
                                    onmouseover="this.style.backgroundColor='#1a7a54'"
                                    onmouseout="this.style.backgroundColor='#176e4d'">
                                💾 שמור שינויים
                            </button>
                            
                            <button type="button" onclick="window.cleaningController.deleteCleaning(event)" 
                                    data-id="${cleaningId}" 
                                    style="background: #e88873; color: white; border: 1px solid #e88873; padding: 12px 24px; border-radius: 5px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background-color 0.2s ease;"
                                    onmouseover="this.style.backgroundColor='#e67a63'"
                                    onmouseout="this.style.backgroundColor='#e88873'">
                                🗑️ מחק ניקיון
                            </button>
                            
                            <button type="button" onclick="this.closest('.edit-cleaning-modal').remove()" 
                                    style="background: #6c757d; color: white; border: 1px solid #6c757d; padding: 12px 24px; border-radius: 5px; font-size: 14px; font-weight: 600; cursor: pointer; transition: background-color 0.2s ease; margin-right: auto;"
                                    onmouseover="this.style.backgroundColor='#5a6268'"
                                    onmouseout="this.style.backgroundColor='#6c757d'">
                                ❌ ביטול
                            </button>
                        </div>
                    </div>
                </div>
                
                <style>
                    .edit-cleaning-modal input:focus,
                    .edit-cleaning-modal select:focus,
                    .edit-cleaning-modal textarea:focus {
                        outline-offset: -2px;
                        outline: 2px solid #176e4d;
                        border-color: #176e4d;
                    }
                    
                    .edit-cleaning-modal input[type="checkbox"]:focus {
                        outline: 2px solid #176e4d;
                        outline-offset: 2px;
                    }
                    
                    @media (max-width: 768px) {
                        .edit-cleaning-modal .form-row {
                            grid-template-columns: 1fr !important;
                        }
                        
                        .edit-cleaning-modal .modal-content {
                            margin: 20px;
                            width: calc(100% - 40px);
                        }
                        
                        .edit-cleaning-modal .modal-footer {
                            flex-direction: column;
                        }
                        
                        .edit-cleaning-modal .modal-footer button {
                            width: 100%;
                        }
                    }
                </style>
            `;
            
            document.body.insertAdjacentHTML('beforeend', modalHtml);
            
        } catch (error) {
            console.error("Error fetching cleaning data:", error);
            alert("שגיאה בטעינת נתוני הניקיון: " + (error.message || "אנא נסה שנית"));
        }
    }

    closeEditModal() {
        const modal = document.getElementById('edit-cleaning-modal');
        if (modal) {
            modal.remove();
        }
        
        // Remove the styles
        const styles = document.getElementById('cleaning-modal-styles');
        if (styles) {
            styles.remove();
        }
    }

    saveEditedCleaning(e) {
        const cleaningId = e.target.dataset.id;
        if (!cleaningId) {
            console.error("No cleaning ID found in button data", e.target);
            return;
        }
        
        const form = document.getElementById('edit-cleaning-form');
        if (!form) {
            console.error("Edit form not found");
            return;
        }
        
        // Get the selected date - try multiple possible sources
        const selectedDate = 
            document.querySelector('input[name="selected_date"]')?.value || 
            document.querySelector('input[data-vacancies-target="date"]')?.value || 
            new Date().toISOString().split('T')[0];
        
        console.log("Using selected date:", selectedDate);
        
        const data = {
            new_expected_date: form.elements.cleaning_expected_date.value,
            id: parseInt(cleaningId), 
            space_id: form.elements.space_id.value,
            num_in_room: parseInt(form.elements.guest_count.value) || 0,
            sheets: form.elements.sheets.checked,
            towels: form.elements.towels.checked,
            note: form.elements.notes.value || "",
            cleaning_type: form.elements.cleaning_type.value,
            cleaning_time: form.elements.cleaning_time.value
        };
        
        console.log("Saving edited cleaning data:", data);
        
        // Wrap the stimulate call in a try/catch to catch any immediate errors
        try {
            this.stimulate("vacancies#update_order_expected_date", 
                selectedDate, 
                [parseInt(cleaningId)], 
                [data]
            ).then(() => {
                console.log("Cleaning updated successfully");
                this.closeEditModal();
                // Reload the page to reflect changes
                window.location.reload();
            }).catch(error => {
                console.error("Error updating cleaning:", error);
                alert("שגיאה בעדכון הניקיון: " + (error.message || "אנא נסה שנית"));
            });
        } catch (error) {
            console.error("Exception during stimulate call:", error);
            alert("שגיאה בעת ניסיון לעדכן את הניקיון");
        }
    }

    async getSpaceOptions(currentSpaceId) {
        try {
            // Fetch spaces from the server - you may need to adjust this endpoint
            const response = await fetch('/spaces.json?kind=room,classroom');
            const spaces = await response.json();
            
            let options = '';
            spaces.forEach(space => {
                const selected = space.id == currentSpaceId ? 'selected' : '';
                options += `<option value="${space.id}" ${selected}>${space.name} (${space.kind})</option>`;
            });
            
            return options;
        } catch (error) {
            console.error('Error fetching spaces:', error);
            // Fallback - return a basic option
            return `<option value="${currentSpaceId}">חדר ${currentSpaceId}</option>`;
        }
    }

    async deleteCleaning(e) {
        const cleaningId = e.target.dataset.id;
        
        if (!cleaningId) {
            console.error("No cleaning ID found");
            return;
        }
        
        if (!confirm('האם אתה בטוח שברצונך למחוק את הניקיון הזה?')) {
            return;
        }
        
        try {
            // Call the delete endpoint
            const response = await fetch(`/vacancies/${cleaningId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            });
            
            if (response.ok) {
                // Remove the modal
                document.querySelector('.edit-cleaning-modal')?.remove();
                // Reload the page to refresh the table
                window.location.reload();
            } else {
                throw new Error('Failed to delete cleaning');
            }
        } catch (error) {
            console.error('Error deleting cleaning:', error);
            alert('שגיאה במחיקת הניקיון');
        }
    }
}